import { useAlert as useAlertHook } from "components/Alerts/hooks"
import { alerts } from "keys"

const useAlert = () => {
    const { setAlerts } = useAlertHook()

    const handleCreateGradeAlert = (value) => {
        setAlerts(alerts.createGrade, value)
    }

    return handleCreateGradeAlert
}

export default useAlert